import type { Epic } from '../../index.js'
import { catchError, filter, map, switchMap } from 'rxjs/operators'
import { of } from 'rxjs'
import { projectSlice } from '../../Slice/Project/ProjectSlice.js'

export const InviteProjectParticipantEpic: Epic = (action$, state$, { [projectSlice.name]: project, InviteRepository }) => {
  return action$.pipe(
    filter(project.inviteProjectParticipantRequest.match),
    switchMap((action) => {
      const { projectId, participantEmail, additionalText, mayEdit } = action.payload
      return InviteRepository.inviteProjectParticipant(projectId, { participantEmail, additionalText, mayEdit }).pipe(
        map((invite) => projectSlice.actions.inviteProjectParticipantRequestSuccess(invite)),
        catchError((error) => of(projectSlice.actions.inviteProjectParticipantRequestFailure({ error })))
      )
    })
  )
}
